'use strict';

var _ = require('lodash');
var ExtractConfigFactory = function ExtractConfigFactory(constants, AppliedFiltersBuilder, momentService) {
  function convertFiltersToString(appliedFilters) {
    var momentDateStringified = _.transform(appliedFilters, function (result, entry) {
      if (momentService.isMoment(entry.inputFilter)) {
        entry.inputFilter = entry.inputFilter.toISOString();
      }
      return result.push(entry);
    });
    return JSON.stringify({
      filters: momentDateStringified
    });
  }
  function convertFiltersToArray(filters) {
    return filters ? JSON.parse(filters).filters : filters;
  }
  function ExtractConfig(levels, edited, userList) {
    edited = edited || {};
    this.levels = levels;
    this.extractName = edited.extractName || '';
    this.description = edited.description || '';
    this.extractFields = edited.fields || [];
    this.appliedFilters = convertFiltersToArray(edited.appliedFilters) || [];
    this.appliedFiltersInput = this.appliedFilters;
    this.fileName = edited.fileName || '';
    this.compressOutput = edited.compressOutput || false;
    this.userId = edited.userId;
    this.saveOption = edited.saveOption || constants.SAVE_OPTION.FTP;
    this.withTimeStampCreation = edited.withTimeStampCreation || false;
    this.email = edited.email || {};
    if (edited.email) {
      this.email.recipients = convertUserIdToUserIdAndUsername(edited.email.recipients, userList) || [];
    }
    if (edited.level) {
      this.level = _.find(levels, ['name', edited.level.name]);
    }
  }
  function convertUserIdToUserIdAndUsername(recipients, userList) {
    return _.filter(userList, function (user) {
      return _.includes(recipients, _.split(user, ' (', 1)[0]);
    });
  }
  function generateQuery(filters) {
    return new AppliedFiltersBuilder(filters).query();
  }
  ExtractConfig.prototype.getExtractFormData = function (formData) {
    formData.level = this.level;
    formData.extractName = this.extractName;
    formData.fields = this.extractFields;
    formData.appliedFilters = convertFiltersToString(this.appliedFilters);
    formData.query = generateQuery(this.appliedFilters);
    formData.compressOutput = this.compressOutput;
    formData.saveOption = this.saveOption;
    formData.withTimeStampCreation = this.withTimeStampCreation;
    formData.fileName = this.fileName;
    formData.description = this.description;
    formData.email = _.cloneDeep(this.email);
    formData.email.recipients = convertUserDetailsToId(formData.email.recipients);
    if (this.userId) {
      formData.userId = this.userId;
    }
    return formData;
  };
  function convertUserDetailsToId(recipients) {
    return _.map(recipients, function (recipient) {
      return recipient.split(' (')[0];
    });
  }
  return ExtractConfig;
};
ExtractConfigFactory.$inject = ['DataExtractConstants', 'AppliedFiltersBuilderFactory', 'MomentService'];
module.exports = ExtractConfigFactory;